module.exports = __webpack_public_path__ + "static/media/logogamovorebrown.a6e421bd.png";